import { useTranslation } from "react-i18next";
import { Checkbox, Grid, GridColumn } from "semantic-ui-react";

import { NavPortal, SearchFilter } from "components";
import "modules/CustomersDashboard/components/CustomerFilters/CustomerFilters.scss";
import { setFilters, useCustomersFilters } from "modules/CustomersDashboard/components/CustomerFilters/hooks";

import type { FormEvent } from "react";
import type { CheckboxProps } from "semantic-ui-react";

export const CustomerFilters = () => {
  const { t } = useTranslation();

  const { filters } = useCustomersFilters();

  const handleLeaseChange = (_e: FormEvent<HTMLInputElement>, { checked }: CheckboxProps) => setFilters({ ...filters, is_lease_company: checked || null, page: 1 });
  const handleSearchChange = (searchTerm: string) => setFilters({ ...filters, search_term: searchTerm, page: 1 });

  return (
    <div className="CustomerFilters">
      <NavPortal>
        <SearchFilter value={filters.search_term || ""} handleSearchChange={handleSearchChange} />
      </NavPortal>

      <Grid className="CustomerFilters__toolbar-grid">
        <GridColumn className="CustomerFilters__no-left-gutter">
          <Checkbox
            className="CustomerFilters__lease_company_label"
            label={t("v8_lease_company", "Lease Company")}
            toggle
            checked={Boolean(filters.is_lease_company)}
            onChange={handleLeaseChange}
          />
        </GridColumn>
      </Grid>
    </div>
  );
};
